// Profil (design_handoff_profil §1): Widget-Hülle (Radius 28) mit Kopf aus 38-px-Icon-Kachel, Titel und Untertitel.
import type { CSSProperties, ElementType, FormEvent, ReactNode } from 'react';

/** Farbverlauf einer Icon-Kachel aus einem Token (statt fester Prototyp-Farben). */
export const verlauf = (token: string) => `linear-gradient(160deg, color-mix(in srgb, var(${token}) 65%, #fff), var(${token}))`;

export function KopfIcon({ children, flaeche, farbe = '#fff' }: { children: ReactNode; flaeche: string; farbe?: string }) {
  return (
    <span className="flex shrink-0 items-center justify-center"
      style={{ width: 38, height: 38, borderRadius: 12, background: flaeche, color: farbe, boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.35)' }}>
      {children}
    </span>
  );
}

export function ProfilWidget({ titel, untertitel, icon, spalte, children, als: Tag = 'section', style, ...rest }: {
  titel: string; untertitel?: string; icon: ReactNode; spalte: string; children: ReactNode; als?: ElementType; style?: CSSProperties;
  onSubmit?: (e: FormEvent) => void;
}) {
  return (
    <Tag aria-label={titel} className="immo-glas m-0 flex min-w-0 flex-col" style={{ gridColumn: spalte, borderRadius: 28, padding: '20px 22px 22px', gap: 16, ...style }} {...rest}>
      <div className="flex items-center" style={{ gap: 12 }}>
        {icon}
        <div className="flex min-w-0 flex-1 flex-col">
          <h2 className="m-0" style={{ fontSize: 17, fontWeight: 800, letterSpacing: '-0.02em' }}>{titel}</h2>
          {untertitel && <span style={{ fontSize: 13, color: 'var(--ink3)' }}>{untertitel}</span>}
        </div>
      </div>
      {children}
    </Tag>
  );
}
